import { environment } from './../../../environments/environment';
import { CustomLogger } from '../../shared/custom-logger';
import { ILog } from '../log';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class LogService {
    private _logUrl = environment.logUrl;

    constructor(private _http: HttpClient, private logger: CustomLogger) { }

    getLogItems(params: any, order = ''): Observable<HttpResponse<ILog[]>> {
        let urlSuf = order;

        if (params.ticketNumber) {
          urlSuf += `&ticket.ticketNumber=${params.ticketNumber}`;
        }

        return this._http
            .get<ILog[]>(this._logUrl + urlSuf, {
                params: params,
                observe: 'response'
            })
            .do(data => this.logger.log(data))
            .catch(this.logger.handleError);
    }

    getLog(id: number): Observable<ILog> {
        if (id === 0) {
            return Observable.of(this.initializeLog());
        }
        const url = `${this._logUrl}/${id}`;
        return this._http.get<ILog>(url)
            .do(data => this.logger.log(data))
            .catch(this.logger.handleError);
    }

    initializeLog(): ILog {
        return {
            id: 0,
            message: '',
            user: null,
            datetime: null,
            ticket: null,
            flight: null,
            createdValue: null,
            changeset: null,
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/logs/list/log.service.ts